module.exports = __webpack_public_path__ + "img/new-banner.ad246458.png";